var render, staticRenderFns
import script from "./accountingStatement.vue?vue&type=script&lang=js&"
export * from "./accountingStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d8cbc6",
  null
  
)

export default component.exports